import { useApplicationFlags } from './useApplicationFlags';

export const useTranslationSuffix = (suffix, translationKeys) => {
  const { isOcmOrUpgrade } = useApplicationFlags();

  const getTranslationKey = (baseTranslation) => {
    const variant = `${baseTranslation}.${suffix}`;
    return isOcmOrUpgrade ? variant : baseTranslation;
  };

  if (typeof translationKeys === 'string') {
    return getTranslationKey(translationKeys);
  }

  return Object.entries(translationKeys).reduce((acc, [key, value]) => {
    acc[key] = getTranslationKey(value);
    return acc;
  }, {});
};
